/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type UpdateGooseGamePrizeMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
  name?: Types.Maybe<Types.Scalars["String"]>;
  description?: Types.Maybe<Types.Scalars["String"]>;
  imageUrl?: Types.Maybe<Types.Scalars["String"]>;
  pointCost?: Types.Maybe<Types.Scalars["Float"]>;
  quantityAvailable?: Types.Maybe<Types.Scalars["Float"]>;
  userRedemptionLimit?: Types.Maybe<Types.Scalars["Float"]>;
}>;

export type UpdateGooseGamePrizeMutation = {
  updateGooseGameStoreItem: Pick<Types.GooseGameItem, "id" | "name">;
};

export const UpdateGooseGamePrizeDocument = gql`
  mutation UpdateGooseGamePrize(
    $id: Float!
    $name: String
    $description: String
    $imageUrl: String
    $pointCost: Float
    $quantityAvailable: Float
    $userRedemptionLimit: Float
  ) {
    updateGooseGameStoreItem(
      id: $id
      name: $name
      description: $description
      image_url: $imageUrl
      point_cost: $pointCost
      quantity_available: $quantityAvailable
      user_redemption_limit: $userRedemptionLimit
    ) {
      id
      name
    }
  }
`;

/**
 * __useUpdateGooseGamePrizeMutation__
 *
 * To run a mutation, you first call `useUpdateGooseGamePrizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGooseGamePrizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGooseGamePrizeMutation, { data, loading, error }] = useUpdateGooseGamePrizeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      pointCost: // value for 'pointCost'
 *      quantityAvailable: // value for 'quantityAvailable'
 *      userRedemptionLimit: // value for 'userRedemptionLimit'
 *   },
 * });
 */
export function useUpdateGooseGamePrizeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateGooseGamePrizeMutation,
    UpdateGooseGamePrizeMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateGooseGamePrizeMutation,
    UpdateGooseGamePrizeMutationVariables
  >(UpdateGooseGamePrizeDocument, baseOptions);
}
export type UpdateGooseGamePrizeMutationHookResult = ReturnType<
  typeof useUpdateGooseGamePrizeMutation
>;
export type UpdateGooseGamePrizeMutationResult =
  ApolloReactCommon.MutationResult<UpdateGooseGamePrizeMutation>;
export type UpdateGooseGamePrizeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateGooseGamePrizeMutation,
    UpdateGooseGamePrizeMutationVariables
  >;
